import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions/extension-handler';
import type { ADDoc } from '@atlaskit/editor-common/utils/validator';

import { getRendererSmartButtonExtensionHandlers } from '@confluence/automation-extensions/entry-points/getRendererSmartButtonExtensionHandlers.ts';

import type { TemplatePreviewTemplate } from '../../templatePreviewHelpers.tsx';

import { getMacroExtensionHandler } from './macroExtensionHandler.tsx';
import { getTemplateExtensionHandler } from './templateExtensionHandler.tsx';

export type GetExtensionHandlersArgs = {
	adf: ADDoc;
	cloudId: string;
	userId: string | null;
	contentId?: string;
	spaceKey?: string;
	template?: TemplatePreviewTemplate;
};

export const getExtensionHandlers = (
	extensionHandlerArgs: GetExtensionHandlersArgs,
): ExtensionHandlers => {
	return {
		'com.atlassian.confluence.macro.core': getMacroExtensionHandler(extensionHandlerArgs),
		'com.atlassian.confluence.template': getTemplateExtensionHandler(extensionHandlerArgs),
		'com.atlassian.automation.smart-button': getRendererSmartButtonExtensionHandlers({
			contentId: extensionHandlerArgs.contentId,
			contentType: 'page',
			cloudId: extensionHandlerArgs.cloudId,
		})['com.atlassian.automation.smart-button'],
	};
};
